import api from "./axios";

const API_BASE_URL = "/api/v1/favorites";

export const addFavorite = async (providerId) => {
  const response = await api.post(`${API_BASE_URL}/${providerId}`);
  return response.data;
};

export const removeFavorite = async (providerId) => {
  const response = await api.delete(`${API_BASE_URL}/${providerId}`);
  return response.data;
};

// ✅ Get favorites for current logged-in patient
export const getFavoriteProviders = async () => {
  const response = await api.get(API_BASE_URL);
  return response.data;
};
